import { Button } from "@remo-co/ui-core/src/components/Button";
import { Card } from "@remo-co/ui-core/src/components/Card";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import { useStartTrial } from "modules/userProfile/hooks/useStartTrial/useStartTrial";
import { useStyles } from "./styles";

export const StartFreeTrialCard = () => {
  const { t } = useI18n(["event", "menu"]);
  const styles = useStyles();
  const { handleStartTrial } = useStartTrial({
    startTrialSource: "my-events-header",
  });

  return (
    <Card className={styles.card} innerClassName={styles.cardInner}>
      <Container className={styles.textContainer}>
        <Typography variant="h3" className={styles.title}>
          {t("event:host.your.own.event")}
        </Typography>
        <Typography variant="h5" className={styles.subtitle}>
          {t("event:start.free.trial")}
        </Typography>
        <Typography variant="body1" className={styles.scrollDown}>
          {t("event:scroll.down.upcoming.events")}
        </Typography>
      </Container>
      <Button
        variant="primary"
        color="blue"
        className={styles.startFreeTrialButton}
        aria-label={t("menu:user.menu.start.trial")}
        onClick={handleStartTrial}
      >
        <Typography variant="body1">
          {t("menu:user.menu.start.trial")}
        </Typography>
      </Button>
    </Card>
  );
};
